<template>
<h1>not found</h1>
</template>

<script>
    export default {
        name: "notFound"
    }
</script>

<style scoped>

</style>
